import { Components, Theme } from '@mui/material/styles';

export const MuiStack: Components<Theme>['MuiStack'] = {
  defaultProps: {
    useFlexGap: true,
    gap: 1,
  },
};
